define('modules/editor/collections/elements',['require','exports','module','backbone','../models/element_factory'],function(require, exports, module) {
  var Backbone = require("backbone"),
      ElementFactory = require("../models/element_factory");

  var Serialization = {
    fromJSON: function(json, options) {
      var elements = _.map(json, function(obj) {
        return ElementFactory.fromJSON(obj, options);
      });
      var elementsCollection = new module.exports();
      elementsCollection.reset(elements);
      return elementsCollection;
    }
  };

  module.exports = Backbone.Collection.extend({
    model: ElementFactory,
    comparator: "displayOrder",
    moveElementForward: function(model){
      if(!this.contains(model)){
        return;
      }
      var elementIndex = model.get("displayOrder");
      if(elementIndex === this.length-1){
       return;
      }
      else {
        // get the next element
        var nextEl = this.at(elementIndex + 1);
        // if I am a form and the next element is a freed button, ignore it and
        // pick the next one
        if(nextEl.name === 'element:form:button') {
          nextEl = this.at(elementIndex + 2);
        }
        model.set("displayOrder", nextEl.get("displayOrder"));
        nextEl.set("displayOrder", elementIndex);
        this.sort();
      }
    },
    moveElementBackward: function(model){
      if(!this.contains(model)){
        return;
      }
      var index = this.indexOf(model);
      if(index === 0){
        return;
      }
      else {
        var prevEl = this.at(index-1);
        model.set("displayOrder", prevEl.get("displayOrder"));
        prevEl.set("displayOrder", index);
        this.sort();
      }
    },
  },
  {
    fromJSON: Serialization.fromJSON
  });

});

